<main fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
  <div>
    <h2>Welcome to</h2>
    <h1>Texas Capital Bank!</h1>
  </div>
  <form fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px" [formGroup]="branchForm" class="formContainer">
    <mat-form-field appearance="outline">
      <mat-select matInput placeholder="Select Branch Location" (selectionChange)="onBranchSelectionChange($event)" panelClass="matPanel">
        <mat-optgroup *ngFor="let branchGroup of branchList" [label]="branchGroup.name">
          <mat-option *ngFor="let branch of branchGroup.branches" [value]="branch.branchId">
            {{branch.branchName}}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>
    <button (click)="onBranchSelectionClick($event)" mat-flat-button>SUBMIT</button>
  </form>
</main>

